<template>
  <div class="content">
    <div class="container">
      <div class="error">
        <h1 ref="error.main">{{main}}</h1>
        <div>
          If you are using Internet Explorer, please switch to Firefox, Chrome, Safari or Microsoft Edge. If this error message is displayed in one of the browsers listed, please contact your ProSiebenSat.1 contact person.
        </div>
        <a class="error__link"
           :href="$router.resolve({ name: 'register' }).href">Registration
        </a>
        <br />
        <div>
          Sollten Sie den Internet Explorer verwenden, dann wechseln Sie bitte auf Firefox, Chrome, Safari oder Microsoft Edge. Wird diese Fehlermeldung in einen der aufgeführten Browsern angezeigt, so wenden Sie sich bitte an Ihre ProSiebenSat.1 Ansprechperson.
        </div>
        <a class="error__link"
           :href="$router.resolve({ name: 'register' }).href">Anmeldung
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      main: 'Error 500',
      header: 'default header',
      editable: 'false',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Error.vue